import { Component, OnInit } from '@angular/core';
import { ExcelViewerService } from '../../service/excel-viewer.service';
import { ReportService } from '../../service/report.service';
import { RepoApiService } from '../../service/repo-api.service';
import { NotifierService } from 'angular-notifier';
import { ToplineService } from '../../service/topline.service';
@Component({
  selector: 'app-data-source',
  templateUrl: './data-source.component.html',
  styleUrls: ['./data-source.component.scss']
})
export class DataSourceComponent implements OnInit {

  public dataSourceTableContainer:any = [];
  public dataSourceTable:any = {};
  public AllowParentSelection = true;
  public RestructureWhenChildSameName = false;
  
  constructor(
    public reportService:ReportService,
    private repoService:RepoApiService,
    public eService:ExcelViewerService,
    private notifier:NotifierService,
    public toplineService:ToplineService,
  ) { }

  ngOnInit(): void {
    this.getDataSourceTableList();
  }


  getDataSourceTableList(){
    this.repoService.getDataSourceTablesList(this.toplineService.excelviewer_fileUUID).subscribe((res) =>{
      if(res['status'] == 1){
        this.dataSourceTableContainer = res['result'].map((va:any) =>{
          return {id:va.id,name:va.name,children:va.files}
        })
        this.dataSourceTableContainer = this.process(this.dataSourceTableContainer);
        console.log(this.dataSourceTableContainer,'Hurrah');
      }else{
        this.notifier.notify("error","Something went wrong!")
      }
    })

  }


  closeDataSourceToplineComponent(){
    this.eService.isDataSourceToplineComponent = false;
  }


  private process(data): any {
    let result = [];
    result = data.map((item) => {
      return this.toTreeNode(item);
    });
    return result;
  }

  private toTreeNode(node, parent = null) {
    // console.log(node, parent);
    if(node && node.children) {
      node.children.map(item => {
        if(item['selected'] == true){
          this.dataSourceTable = item;
        }
        return this.toTreeNode(item, node);
      });
    }
    
    return node;
  }


  saveDataSource(){
    if(!Object.keys(this.dataSourceTable).length){
      this.notifier.notify('error','Please Select DataSource File');
    }else{
      let body = {};
      // body['cross_tab_file_id'] = this.toplineService.crosstab_fileUUID;
      body['cross_tab_file_id'] = this.dataSourceTable['id'];
      body['file_id'] = this.toplineService.excelviewer_fileUUID;
      this.repoService.changeDataSourceTableList(body).subscribe(res =>{
        if(res['status'] == 1){
          this.eService.getToplineCrosstabData({uuid:this.dataSourceTable['id']});
          // this.eService.getExcelData();
          this.eService.refreshFilterOptions();
          // this.eService.getFilterOptions();
          this.notifier.notify('success','Data source change successfully');
        }else{
          this.notifier.notify('error','Something went wrong');
        }
      })
    }
    this.closeDataSourceToplineComponent();
  }

}
